import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

/**
 * Results — src/Design/industries/industry-*.html, SECTION 4.
 * Exact 50/50 split, mirrored from Solution: photo on the RIGHT running to
 * the window edge, text on the left, dark navy-band background.
 *
 * The client-logo row that used to live here has moved to its own
 * "Trusted by" section (TrustedBy.js), directly below Results.
 *
 * Most pages point at a single case study (linkLabel/linkHref, rendered as
 * one link). Retail and distribution each have more than one client's
 * case study to credit, so they pass `links` instead — an array of
 * {label, href} — rendered as "Read the case studies: A, B and C" with
 * each name its own link. Pass one or the other, never both.
 */
const Results = ({
  eyebrow,
  heading,
  metrics = [],
  summary,
  linkLabel,
  linkHref,
  links,
  image,
  imageAlt,
}) => {
  // Both metrics in the row must share one font size: if either value is
  // longer than 6 characters (e.g. "Same day", "In sync"), the shorter one
  // would otherwise render much larger than its neighbour and the longer
  // one wraps awkwardly — so a long value downsizes the whole row.
  const rowIsLong = metrics.some(m => m.value.length > 6)

  return (
    <section className="iresults">
      <div className="iresults__media">
        {image && <GatsbyImage image={image} alt={imageAlt || ""} loading="lazy" className="iresults__photo" />}
      </div>
      <div className="iresults__inner">
        <div className="iresults__copy">
          <p className="iresults__eyebrow">{eyebrow}</p>
          <h2 className="iresults__heading">{heading}</h2>

          <div className="iresults__metrics">
            {metrics.map(m => (
              <div key={m.label}>
                <div className={`iresults__metric-num${rowIsLong ? " iresults__metric-num--long" : ""}`}>{m.value}</div>
                <div className="iresults__metric-lbl">{m.label}</div>
              </div>
            ))}
          </div>

          <p className="iresults__summary">{summary}</p>
          {links && links.length > 0 ? (
            <p className="iresults__link-group">
              Read the case studies:{" "}
              {links.map((l, i) => (
                <React.Fragment key={l.href}>
                  {i > 0 && (i === links.length - 1 ? " and " : ", ")}
                  <a
                    className="iresults__link"
                    href={l.href}
                    {...(/^https?:\/\//.test(l.href) ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                  >
                    {l.label}
                  </a>
                </React.Fragment>
              ))}
            </p>
          ) : (
            <a
              className="iresults__link"
              href={linkHref}
              {...(/^https?:\/\//.test(linkHref) ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            >
              {linkLabel}
            </a>
          )}
        </div>
      </div>
    </section>
  )
}

export default Results
